import { AutenticacaoInterface } from "../_interfaces/autenticacao.interface";
import { UtilitariosService } from "../_services/utilitarios/utilitarios.service";

export class Utilitarios {

  public static IsAdmin: boolean = false;

  public static Roles: RolesInterface[] = [];
  public ListarClienteRoles: ListarClienteRolesInterface[] = this.GerarArrayListarClienteRoles();

  private NOME_LOCALSTORAGE_AUTENTICACAO: string = "TokenInfo";

  constructor() {
  }

  private GerarArrayListarClienteRoles(): ListarClienteRolesInterface[] {
    let _arrRetorno: ListarClienteRolesInterface[] = [];

    _arrRetorno.push({ acao: 'roleListarCliente', habilitado: false });

    return _arrRetorno;
  }

  public FormatarData(pData: Date): string {
    //2020-02-12T00:00:00
    var _split = pData.toString().split("-");
    var _splitT = _split[2].split("T");

    return _splitT[0] + "/" + _split[1] + "/" + _split[0];
  }

  public FormatarDataHora(pData: Date): string {
    //2021-01-10T08:33:26.507
    var _split = pData.toString().split("-");
    var _splitT = _split[2].split("T");
    var _splitHora = pData.toString().split(":");
    var _horaInicial = _splitHora[0].substring(_splitHora[0].length - 2);
    var _horaFinal = _splitHora[2].substring(0, 2);

    return _splitT[0] + "/" + _split[1] + "/" + _split[0] + " " + _horaInicial + ":" + _splitHora[1] + ":" + _horaFinal;
  }

  public FormatarHorarioStringToDate(pData: string): Date {
    var _split = pData.split(":");

    return new Date(2021, 1, 1, Number.parseInt(_split[0]), Number.parseInt(_split[1]), Number.parseInt(_split[2]));
  }

  public GerarDias(): number[] {
    var _array: number[] = [];

    for (var i = 1; i <= 31; i++) {
      _array.push(i);
    }

    return _array;
  }

  public GerarArrayBaseDados(): string[] {
    return ["ORACLE", "POSTGRE", "SQL SERVER", "MYSQL", "FIREBIRD", "AURORA"];
  }

  public FormatarCnpj(v: string) {
    v = v.replace(/\D/g, "")                           //Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d)/, "$1.$2")             //Coloca ponto entre o segundo e o terceiro dígitos
    v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3") //Coloca ponto entre o quinto e o sexto dígitos
    v = v.replace(/\.(\d{3})(\d)/, ".$1/$2")           //Coloca uma barra entre o oitavo e o nono dígitos
    v = v.replace(/(\d{4})(\d)/, "$1-$2")              //Coloca um hífen depois do bloco de quatro dígitos

    return v;
  }

  public FormatarHorario(v: string) {
    let _retorno = v;
    if (_retorno.length == 6) {
      _retorno = v.substring(0, 2) + ":" + v.substring(2, 4) + ":" + v.substring(4);
    }

    return _retorno;
  }

  public FormatarCelular(v: string) {
    let _retorno = v;
    if (v.length == 11) {
      _retorno = "(" + v.substring(0, 2) + ") " + v.substring(2, 7) + "-" + v.substring(7);
    }

    return _retorno;
  }

  public GerarArrayGraficos(): string[] {
    return ["CAIXA", "LINHA", "BARRA", "PIZZA"];
  }

  public FormatarDataString(pValor: string) {
    let _retorno = pValor;
    if (pValor.length == 8) {
      _retorno = pValor.substring(0, 2) + "/" + pValor.substring(2, 4) + "/" + pValor.substring(4);
    }

    return _retorno;
  }

  public GerarArrayTaxaAtualizacaoWidget(): number[] {
    return [1, 3, 5, 10, 15, 30, 45, 60];
  }

  public RetornarLocalStorageAutenticacao(): AutenticacaoInterface {
    return <AutenticacaoInterface>JSON.parse(localStorage.getItem(this.NOME_LOCALSTORAGE_AUTENTICACAO));
  }

  public VerificarLocalStorageAutenticacao(): boolean {
    if (localStorage.getItem(this.NOME_LOCALSTORAGE_AUTENTICACAO)) {
      return true;
    }

    return false;
  }

  public GravarItemLocalStorageAutenticacao(pObjString: string) {
    localStorage.setItem(this.NOME_LOCALSTORAGE_AUTENTICACAO, pObjString);
  }

  public RemoverItemLocalStorageAutenticacao() {
    localStorage.removeItem(this.NOME_LOCALSTORAGE_AUTENTICACAO);
  }

  public GerarArrayCicloComissao(): CicloComissao[] {
    let _retorno: CicloComissao[] = [];

    return _retorno;
  }

  public GerrarArrayQtdeMaxParcelasContrato(): QtdeMaxParcelasContratoInterface[] {
    let retorno: QtdeMaxParcelasContratoInterface[] = [];

    for (var i = 1; i <= 36; i++) {

      let dsc = "";

      if (i == 1) {
        dsc = `${i} parcela`;
      }
      else {
        dsc = `${i} parcelas`;
      }

      retorno.push({
        qtdeParcela: i,
        descricao: `${dsc}`
      });

    }

    return retorno;
  }

  public GerarArrayColunasIndicadoresPadsDoisCampanha(): string[] {
    let retorno: string[] = [];

    retorno.push("Nome Campanha");
    retorno.push("Status");
    retorno.push("Tipo");
    retorno.push("Budget");
    retorno.push("Clicks");
    retorno.push("% Clicks");
    retorno.push("Impressões");
    retorno.push("% Impressões");
    retorno.push("Clicks X Impressões");
    retorno.push("% Clicks X Impressões");
    retorno.push("Custo Total Clicks X Periodo");
    retorno.push("% Custo Total");
    retorno.push("Custo Medio por Click");
    retorno.push("% Custo Medio por Click");
    retorno.push("Valor Vendas Direta");
    retorno.push("% Vendas Diretas");
    retorno.push("Valor Vendas Indiretas");
    retorno.push("% Vendas Indiretas");
    retorno.push("Total Vendas");
    retorno.push("% Total Vendas");
    retorno.push("ACOS");
    retorno.push("% ACOS");
    retorno.push("Qtde Vendas Diretas");
    retorno.push("% Vendas Diretas");
    retorno.push("Qtde Vendas Assistidas");
    retorno.push("% Vendas Assistidas");
    retorno.push("Qtde Total Vendas");
    retorno.push("% Qtde Total Vendas");
    retorno.push("Qtde Vendas Diretas PADs");
    retorno.push("% Qtde Vendas Diretas PADs");
    retorno.push("Qtde Vendas Indiretas PADs");
    retorno.push("% Qtde Vendas Indiretas PADs");
    retorno.push("Vendas Por Publicidade");
    retorno.push("% Vendas Por Publicidade");
    retorno.push("Qtde Vendas sem PADs");
    retorno.push("% Qtde Vendas sem PADs");
    retorno.push("Melhor dia da semana");
    retorno.push("Contribuição Visitas");
    retorno.push("% Contribuição Visitas");
    retorno.push("Contribuição Vendas");
    retorno.push("% Contribuição Vendas");
    retorno.push("Investimento X Retorno");
    retorno.push("% ROI");
    retorno.push("Contribuição Sobre Faturamento");
    retorno.push("% Contribuição Sobre Faturamento");
    retorno.push("Qtde Anuncios Ativos");
    retorno.push("Qtde Anuncios Inativos");

    return retorno;
  }

  public GerarArrayColunasIndicadoresPadsDoisAnuncio(): string[] {
    let retorno: string[] = [];

    retorno.push("Nome Campanha");
    retorno.push("Anuncio");
    retorno.push("Descrição");
    retorno.push("Clicks");
    retorno.push("% Clicks"); //4
    retorno.push("Impressões");
    retorno.push("% Impressões"); //6
    retorno.push("CTR");
    retorno.push("% CTR"); //8
    retorno.push("Cost");
    retorno.push("% Cost"); //10
    retorno.push("CPC");
    retorno.push("% CPC"); //12
    retorno.push("Vendas Diretas PROD ADS");
    retorno.push("% Vendas Diretas PROD ADS"); //14
    retorno.push("Vendas Indiretas PROD ADS");
    retorno.push("% Vendas Indiretas PROD ADS"); //16
    retorno.push("Total Vendas PROD ADS");
    retorno.push("% Total Vendas PROD ADS"); //18
    retorno.push("ACOS");
    retorno.push("% ACOS"); //20
    retorno.push("Qtde Vendas Diretas");
    retorno.push("% Qtde Vendas Diretas"); //22
    retorno.push("Qtde Vendas Assistidas");
    retorno.push("% Qtde Vendas Assistidas"); //24
    retorno.push("Total Vendas");
    retorno.push("% Total Vendas"); //26
    retorno.push("Qtde Vendas Diretas PADs");
    retorno.push("% Qtde Vendas Diretas PADs"); //28
    retorno.push("Qtde Vendas Indiretas PADs");
    retorno.push("% Qtde Vendas Indiretas PADs"); //30
    retorno.push("Vendas Publicidade");
    retorno.push("% Vendas Publicidade"); //32
    retorno.push("Qtde Vendas sem PADs");
    retorno.push("% Qtde Vendas sem PADs"); //34
    retorno.push("Melhor dia de venda");
    retorno.push("Contribuição visitas");
    retorno.push("% Contribuição visitas"); //37
    retorno.push("Contribuição vendas");
    retorno.push("% Contribuição vendas"); //39
    retorno.push("Investimento X Retorno");
    retorno.push("% ROI"); //41
    retorno.push("Contribuição sobre faturamento");
    retorno.push("% Contribuição sobre faturamento"); //43


    //retorno.push("PEDIDOS_PERIODO");
    //retorno.push("QTDE_VENDAS_DIRETAS_PADS_PERIODO_ANTERIOR");
    //retorno.push("ORCAMENTO_DIARIO");
    //retorno.push("DIA_COM_MAIS_VENDA");
    //retorno.push("VALOR_MELHOR_DIA");
    //retorno.push("FAT_PERIODO");
    //retorno.push("FATURAMENTO_PERIODO_ANTERIOR");
    //retorno.push("CONTRIBUICAO_SOBRE_FATURAMENTO_PERIODO_ANTERIOR");    
    //retorno.push("PEDIDOS_PERIODO_ANTERIOR");
    //retorno.push("CONTRIBUICAO_VENDAS_PERIODO_ANTERIOR");
    //retorno.push("CONTRIBUICAO_VISITAS_PERIODO_ANTERIOR");


    return retorno;
  }
}

export interface RolesInterface {
  nmAcao?: string,
  dsRota?: string,

  acao: string,
  rota: string
}

export interface ListarClienteRolesInterface {
  acao: string,
  habilitado: boolean
}

export interface CicloComissao {
  value: string,
  display: string
}

export interface QtdeMaxParcelasContratoInterface {
  qtdeParcela: number,
  descricao: string
}

export interface RptAdScoreInterface {
  value: string,
  display: string
}
